
export const screenMaxWidth = {
  MOBILE: 812,
};

export enum jobInstanceStatus {
  FAILED = 'FAILED',
  DONE = 'DONE',
};

export const CONSTANTS = {
  artifactTypeCodeSortOrder: ['ACTION', 'REPORT', 'AUDIT', 'IDS', 'LOG', 'DEBUG'],
  enterDelay: 300,
  dateFormatForUI: 'MMM dd, yyyy',
  defaultErrorMessageKey: 'transit.error.default.message',
  lockErrorMessageKey: 'transit.error.lock.failed.message',
  minYears: 1900,
  maxIntegerValue: 999,
  maxYears: 2100,
  pageSizes: [10, 20],
  successNotificationDuration: 5000,
};

export const URLS = {
  help: 'https://resources.elluciancloud.com/csh?context=degree_works_documentation',
};

export enum SortDirections {
  ASC = 'asc',
  DESC = 'desc',
}

export const Endpoint = () => (window as any).transit_endpoint;

export const dialogPopperProps = {
  modifiers: [
    {
      name: 'flip',
      enabled: true,
      options: {
        altBoundary: true,
        rootBoundary: 'document',
        padding: 8,
      },
    },
    {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altAxis: true,
        altBoundary: true,
        tether: true,
        rootBoundary: 'document',
        padding: 8,
      },
    },
  ]
};
